import "./App.css";
import Home from "./Components/Home/Home";
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import About from "./Components/NavItems/About";
import ProjectsMain from "./Components/NavItems/ProjectsMain";
import BlogMain from "./Components/NavItems/BlogMain";
import Contact from "./Components/NavItems/Contact";
import ProjectsDetails from "./Components/ProjectsDetails/ProjectsDetails";
// import Particles from "react-tsparticles"; , Link

function App() {
  // const particlesInit = (main) => {
  //   console.log(main);
  // };

  // const particlesLoaded = (container) => {
  //   console.log(container);
  // };
  return (
    <div>
      {/* <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          fpsLimit: 60,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              bubble: {
                distance: 250,
                duration: 2,
                opacity: 0.8,
                size: 40,
              },
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: "#ffffff",
            },
            links: {
              color: "#ffffff",
              distance: 150,
              // enable: true,
              opacity: 0.5,
              width: 1,
            },
            collisions: {
              enable: true,
            },
            move: {
              direction: "none",
              enable: true,
              outMode: "bounce",
              random: false,
              speed: 2,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                value_area: 800,
              },
              value: 48,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              random: true,
              value: 5,
            },
          },
          detectRetina: true,
        }}
      /> */}
      <Router>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/home">
            <Home />
          </Route>
          <Route path="/about-me">
            <About />
          </Route>
          <Route path="/projects">
            <ProjectsMain />
          </Route>
          <Route path="/projectsdetails/:projectsid">
            <ProjectsDetails />
          </Route>
          <Route path="/blogs">
            <BlogMain />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="*">
            <Home />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
